"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.LogLevel = void 0;
var LogLevel;
(function (LogLevel) {
    LogLevel[LogLevel["TRACE"] = 0] = "TRACE";
    LogLevel[LogLevel["INFO"] = 1] = "INFO";
    LogLevel[LogLevel["WARN"] = 2] = "WARN";
    LogLevel[LogLevel["ERROR"] = 3] = "ERROR";
    LogLevel[LogLevel["TEST"] = 4] = "TEST";
    LogLevel[LogLevel["NONE"] = 5] = "NONE";
})(LogLevel || (exports.LogLevel = LogLevel = {}));
let LOG_LEVEL;
class Log {
    static parseLogLevel() {
        try {
            let valToSwitch;
            if (typeof Log.Level === "undefined") {
                valToSwitch = (process.env.LOG_LEVEL || "").toUpperCase();
            }
            else {
                valToSwitch = Log.Level;
            }
            if (typeof valToSwitch !== "string") {
                LOG_LEVEL = Log.Level;
                return LOG_LEVEL;
            }
            else {
                switch (valToSwitch) {
                    case "TRACE":
                        LOG_LEVEL = LogLevel.TRACE;
                        break;
                    case "INFO":
                        LOG_LEVEL = LogLevel.INFO;
                        break;
                    case "WARN":
                        LOG_LEVEL = LogLevel.WARN;
                        break;
                    case "ERROR":
                        LOG_LEVEL = LogLevel.ERROR;
                        break;
                    case "TEST":
                        LOG_LEVEL = LogLevel.TEST;
                        break;
                    case "NONE":
                        LOG_LEVEL = LogLevel.NONE;
                        break;
                    default:
                        LOG_LEVEL = LogLevel.TRACE;
                }
                Log.Level = LOG_LEVEL;
                return LOG_LEVEL;
            }
        }
        catch (_err) {
            console.log("<E> Log::parseLogLevel() - ERROR; setting to TRACE");
            Log.Level = LogLevel.TRACE;
            LOG_LEVEL = LogLevel.TRACE;
            return LOG_LEVEL;
        }
    }
    static trace(...msg) {
        if (Log.Level <= LogLevel.TRACE) {
            console.log(`<T> ${Log.getCurrentTS()}`, ...msg);
        }
    }
    static cmd(msg) {
        if (Log.Level <= LogLevel.INFO) {
            console.info(`\`\`\`\n${msg}\n\`\`\``);
        }
    }
    static info(...msg) {
        if (Log.Level <= LogLevel.INFO) {
            console.info(`<I> ${Log.getCurrentTS()}`, ...msg);
        }
    }
    static warn(...msg) {
        if (Log.Level <= LogLevel.WARN) {
            console.warn(`<W> ${Log.getCurrentTS()}`, ...msg);
        }
    }
    static error(...msg) {
        if (Log.Level <= LogLevel.ERROR) {
            console.error(`<E> ${Log.getCurrentTS()}`, ...msg);
        }
    }
    static exception(...err) {
        console.error(`<!> ${Log.getCurrentTS()}`, ...err);
    }
    static test(...msg) {
        if (Log.Level <= LogLevel.TEST) {
            console.log(`<X> ${Log.getCurrentTS()}`, ...msg);
        }
    }
    static getCurrentTS() {
        let dateStr = new Date().toLocaleString() + ":";
        dateStr = dateStr.padEnd(23, " ");
        return dateStr;
    }
}
Log.Level = Log.parseLogLevel();
exports.default = Log;
Log.parseLogLevel();
